import React from "react";
import useClickedOutside from "../../../hooks/useClickedOutside";
import { Container } from "./styles";

const HelpModal = ({ helpContents, helpPosition, close }) => {
  const ref = useClickedOutside(close);

  return (
      <Container ref={ref} style={{ left: helpPosition.x, top: helpPosition.y }}>
        {helpContents}
      </Container>
  );
};

  export default HelpModal;
